/**
 * Consent-banner copy (plan/09 §2). Legally constrained — polish, don't lengthen.
 * The banner offers three equal-weight actions (no dark patterns): Decline is one
 * click, same size/weight as Accept. Wired to the ConsentBanner component in P5.
 */
export const consent = {
	label: 'Privacy choices',
	body: 'Allow analytics to help us improve the site, and advertising cookies and similar technology for ad measurement and personalized ads on Meta and Google. You can change your choice anytime.',
	actions: {
		accept: 'Accept all',
		analytics: 'Analytics only',
		decline: 'Decline',
		details: 'Details'
	},
	detailsHref: '/legal/privacy#analytics',
	/** Footer link that reopens the banner (withdraw as easily as give). */
	reopenLabel: 'Cookie choices'
} as const;
